'use strict';

define(['app'], function (app) {

  var productPrice = function productPrice() {
    var component = {};

    var _config = {
      selectors: {
        component: '[data-component=productPrice]',
        rrp: '[data-product-price=rrp]',
        price: '[data-product-price=price]',
        saving: '[data-product-price=saving]',
        schemaPrice: '[data-schema=price]',
        fromPrice: '[data-product-price="fromPrice"]',
        professionalPricingBanner: '[data-product-price=professionalPricingBanner]',
        optionTerm: '[data-product-price=paymentOptionTerm]',
        monthSingular: '[data-product-price=optionMonthTextSingular]',
        monthPlural: '[data-product-price=optionMonthTextPlural]',
        recurringPaymentText: '[data-product-price=recurringPaymentText]'
      },
      subscribeChannels: {
        price: 'productPrice/newPrice',
        subscriptionTerm: 'subscriptionComponent/subscriptionTerm',
        subscriptionType: 'subscriptionComponent/subscriptionType'
      }
    };

    var _init = function _init(element) {
      component.element = element;

      var priceSubscribe = app.subscribe(component.config.subscribeChannels.price, component.getNewPrice);
      component.checkSubscribeMessages(priceSubscribe, component.getNewPrice);

      var termSubscribe = app.subscribe(component.config.subscribeChannels.subscriptionTerm, component.getNewTerm);
      component.checkSubscribeMessages(termSubscribe, component.getNewTerm);

      var subscriptionType = app.subscribe(component.config.subscribeChannels.subscriptionType, component.getNewSubscriptionType);
      component.checkSubscribeMessages(subscriptionType, component.getNewSubscriptionType);

      return component;
    };

    var _priceReceived = function _priceReceived(priceData) {
      component.element.classList.add("productPrice_reverseColumns");
      var newContainer = document.createElement('div');
      newContainer.innerHTML = priceData;
      var newElem = newContainer.querySelector(component.config.selectors.component);

      var schemaPriceUpdate = newElem.querySelector(component.config.selectors.schemaPrice);
      var rrpUpdate = newElem.querySelector(component.config.selectors.rrp);
      var priceUpdate = newElem.querySelector(component.config.selectors.price);
      var savingUpdate = newElem.querySelector(component.config.selectors.saving);
      var fromPriceUpdate = newElem.querySelector(component.config.selectors.fromPrice);
      var professionalPricingBannerUpdate = newElem.querySelector(component.config.selectors.professionalPricingBanner);
      var schemaPriceCurrent = component.element.querySelector(component.config.selectors.schemaPrice);
      var rrpCurrent = component.element.querySelector(component.config.selectors.rrp);
      var priceCurrent = component.element.querySelector(component.config.selectors.price);
      var savingCurrent = component.element.querySelector(component.config.selectors.saving);
      var fromPriceCurrent = component.element.querySelector(component.config.selectors.fromPrice);
      var professionalPricingBannerCurrent = component.element.querySelector(component.config.selectors.professionalPricingBanner);

      if (schemaPriceCurrent) {
        component.element.removeChild(schemaPriceCurrent);
      }

      if (schemaPriceUpdate) {
        component.element.appendChild(schemaPriceUpdate);
      }

      if (rrpCurrent) {
        component.element.removeChild(rrpCurrent);
      }

      if (rrpUpdate) {
        component.element.appendChild(rrpUpdate);
      }

      if (fromPriceCurrent) {
        component.element.removeChild(fromPriceCurrent);
      }

      if (fromPriceUpdate) {
        component.element.appendChild(fromPriceUpdate);
      }

      if (priceCurrent) {
        component.element.removeChild(priceCurrent);
      }

      if (priceUpdate) {
        component.element.appendChild(priceUpdate);
      }

      if (savingCurrent) {
        component.element.removeChild(savingCurrent);
      }

      if (savingUpdate) {
        component.element.appendChild(savingUpdate);
      }

      if (professionalPricingBannerCurrent) {
        component.element.removeChild(professionalPricingBannerCurrent);
      }

      if (professionalPricingBannerUpdate) {
        component.element.appendChild(professionalPricingBannerUpdate);
      }
    };

    var _getNewPrice = function _getNewPrice(productId) {
      app.ajax.get({
        url: '/' + productId + '.price',
        success: component.successHandler,
        error: component.errorHandler
      });
    };

    var _getNewTerm = function _getNewTerm(subscriptionTerm) {
      var termElement = component.element.querySelector(component.config.selectors.optionTerm);
      var monthSingular = component.element.querySelector(component.config.selectors.monthSingular);
      var monthPlural = component.element.querySelector(component.config.selectors.monthPlural);

      if (termElement && monthSingular && monthPlural) {
        termElement.innerHTML = subscriptionTerm;

        if (subscriptionTerm === '1') {
          monthSingular.classList.remove("productPrice_hideMonth");
          if (!monthPlural.classList.contains("productPrice_hideMonth")) {
            monthPlural.classList.add("productPrice_hideMonth");
          }
        } else {
          monthPlural.classList.remove("productPrice_hideMonth");
          if (!monthSingular.classList.contains("productPrice_hideMonth")) {
            monthSingular.classList.add("productPrice_hideMonth");
          }
        }
      }
    };

    var _getNewSubscriptionType = function _getNewSubscriptionType(subscriptionType) {
      var recurringPaymentTextEl = component.element.querySelector(component.config.selectors.recurringPaymentText);
      if (recurringPaymentTextEl) {
        if (subscriptionType === 'recurring') {
          if (!recurringPaymentTextEl.classList.contains("productPrice_hideRecurringPaymentText")) {
            recurringPaymentTextEl.classList.add("productPrice_hideRecurringPaymentText");
          }
        }
        // upfront payment
        else if (subscriptionType === 'upfront' && recurringPaymentTextEl.classList.contains("productPrice_hideRecurringPaymentText")) {
            recurringPaymentTextEl.classList.remove("productPrice_hideRecurringPaymentText");
          }
      }
    };

    var _successHandler = function _successHandler(response) {
      component.priceReceived(response);
    };

    var _errorHandler = function _errorHandler() {
      console.error('ERROR: Could not retrieve new price options');
    };

    var _checkSubscribeMessages = function _checkSubscribeMessages(subscription, callback) {
      if (subscription.messages.length > 0) {
        var lastItem = subscription.messages.slice(-1)[0];
        callback(lastItem);
      }
    };

    component.init = _init;
    component.config = _config;
    component.priceReceived = _priceReceived;
    component.getNewPrice = _getNewPrice;
    component.successHandler = _successHandler;
    component.errorHandler = _errorHandler;
    component.checkSubscribeMessages = _checkSubscribeMessages;
    component.getNewTerm = _getNewTerm;
    component.getNewSubscriptionType = _getNewSubscriptionType;

    return component;
  };

  return productPrice;
});
//# sourceMappingURL=productPrice.js.map
